<ap-panel class="shadow mt-2 align-items-stretch h-100">
  <h4 class="pt-3">
    {{ 'dashboard.taxNews.title' | translate }}
  </h4>
  @if (selectedClient()) {
    <p>{{ 'dashboard.taxNews.description' | translate }}</p>
    <div class="overflow-auto" style="height: 400px">
      @if (taxNewsList()?.length !== 0) {
        @for (taxNews of taxNewsList(); track $index) {
          <gstar-tax-news-card
            (reloadNews)="reloadNews()"
            (click)="openTaxNews(taxNews)"
            class="col-12 col-md-6 col-lg-4 p-3 clickable"
            [taxNews]="taxNews" />
        }
      } @else if (selectedCountryName()) {
        <p>
          {{
            'dashboard.taxNews.noTaxNewsWithSelectedCountry'
              | translate: { name: selectedCountryName() }
          }}
        </p>
      }
    </div>
  } @else {
    <p>{{ 'dashboard.taxNews.noClientDescription' | translate }}</p>
  }
</ap-panel>

<gstar-tax-news-detail-modal [taxNews]="selectedTaxNews()" />
